import type { SVGProps } from 'react';

const SvgAutoViewing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 32 32'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M30.67 20.297a1 1 0 0 1 1 1A10.327 10.327 0 0 1 21.335 31.63a1 1 0 0 1-.858-1.514l1.4-2.334a1 1 0 1 1 1.715 1.03l-.361.602a8.328 8.328 0 0 0 6.437-8.117 1 1 0 0 1 1-1ZM8.774 2.513a8.328 8.328 0 0 0-6.438 8.117 1 1 0 1 1-2 0A10.327 10.327 0 0 1 10.669.297a1 1 0 0 1 .858 1.514l-1.4 2.334a1 1 0 0 1-1.715-1.03l.362-.602Z'
      fill='#FEBB00'
      fillRule='evenodd'
      opacity={0.4}
    />
    <path
      d='M19.805 20.444a8.223 8.223 0 0 1-8.227 8.226 8.223 8.223 0 0 1-8.226-8.227 8.223 8.223 0 0 1 8.226-8.226c.214 0 .414.013.64.026a8.232 8.232 0 0 1 7.574 7.574c0 .2.013.4.013.627Z'
      fill='#FEBB00'
      opacity={0.4}
    />
    <path
      d='M11.161 22.338c-.066 0-.11.015-.132.047-.022.023-.033.066-.033.128v1.72c0 .109-.025.187-.077.234-.044.046-.117.07-.22.07H9.37c-.096 0-.17-.024-.221-.07a.365.365 0 0 1-.066-.234v-7.58c0-.108.022-.186.066-.233.051-.047.125-.07.22-.07h2.585c2.267 0 3.4.986 3.4 2.959 0 .998-.297 1.754-.891 2.269-.594.506-1.456.76-2.585.76h-.716Zm0-4.117c-.066 0-.11.015-.132.047-.022.023-.033.066-.033.128v1.895c0 .063.011.11.033.14.022.024.066.036.132.036h.716c.49 0 .861-.094 1.11-.281.257-.195.386-.484.386-.866s-.125-.659-.374-.83c-.242-.18-.616-.269-1.123-.269h-.715ZM28.672 11.563a8.223 8.223 0 0 1-8.227 8.226h-.653a8.232 8.232 0 0 0-7.573-7.573v-.653a8.223 8.223 0 0 1 8.226-8.227 8.223 8.223 0 0 1 8.227 8.227Z'
      fill='#FEBB00'
    />
  </svg>
);
export default SvgAutoViewing;
